export default "__VITE_ASSET__9dd1e1b0__"